'use strict';

var _ = require('lodash');
var SponsorFlightTransformerFactory = function SponsorFlightTransformerFactory(DataTransformer, momentService) {
  function SponsorFlightTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'sponsor-forecast-flight';
    this.priority = 1;
  }
  SponsorFlightTransformer.prototype = Object.create(DataTransformer.prototype);
  SponsorFlightTransformer.constructor = SponsorFlightTransformer;
  SponsorFlightTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  SponsorFlightTransformer.prototype.isCacheable = function () {
    return true;
  };
  SponsorFlightTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  SponsorFlightTransformer.prototype.transform = function (data) {
    if (data.domain.departureDateSchedules === undefined) {
      return undefined;
    }
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    return _.transform(data.domain.departureDateSchedules, function (result, entry) {
      return result.push({
        departureDate: memoizedMomentOfDate(entry.departureDate, momentService.FIELD.DEPARTURE_DATE),
        legSchedules: entry.legSchedules
      });
    });
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return SponsorFlightTransformer;
};
SponsorFlightTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = SponsorFlightTransformerFactory;